import React, { CSSProperties } from "react";

export default function IconVelavuUser(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 3.75C7.1211 3.75 3 7.8711 3 12.75C3 15.6201 4.4328 18.2202 6.6 19.8816V19.95H6.6918C8.193 21.0705 10.0317 21.75 12 21.75C13.9683 21.75 15.807 21.0705 17.3082 19.95H17.4V19.8816C19.5672 18.2202 21 15.621 21 12.75C21 7.8711 16.8789 3.75 12 3.75ZM8.4666 18.9843C8.59923 18.3844 8.93239 17.8475 9.41112 17.4624C9.88986 17.0772 10.4856 16.8668 11.1 16.8657H12.9C13.5144 16.8669 14.11 17.0775 14.5887 17.4626C15.0674 17.8477 15.4006 18.3844 15.5334 18.9843C14.4822 19.5936 13.2744 19.95 12 19.95C10.7256 19.95 9.5178 19.5936 8.4666 18.9843ZM17.049 17.8269C16.7057 17.0096 16.129 16.3117 15.391 15.8205C14.653 15.3294 13.7865 15.0668 12.9 15.0657H11.1C10.2135 15.0668 9.34704 15.3294 8.60904 15.8205C7.87104 16.3117 7.2943 17.0096 6.951 17.8269C5.6307 16.5138 4.8 14.7084 4.8 12.75C4.8 8.8467 8.0967 5.55 12 5.55C15.9033 5.55 19.2 8.8467 19.2 12.75C19.2 14.7084 18.3693 16.5138 17.049 17.8269Z"
				fill={props.color ?? "black"}
			/>
			<path
				d="M12 7.34979C9.94799 7.34979 8.39999 8.89779 8.39999 10.9498C8.39999 13.0018 9.94799 14.5498 12 14.5498C14.052 14.5498 15.6 13.0018 15.6 10.9498C15.6 8.89779 14.052 7.34979 12 7.34979ZM12 12.7498C10.9398 12.7498 10.2 12.01 10.2 10.9498C10.2 9.88959 10.9398 9.14979 12 9.14979C13.0602 9.14979 13.8 9.88959 13.8 10.9498C13.8 12.01 13.0602 12.7498 12 12.7498Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
